import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class DepositBonusConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isDepositBonusesDetailedViewEnabled(): boolean {
		return this.service.get((x) => x.matCommonUi.depositBonus.enabled, true);
	}

	isDepositBonusesDetailTermsVisible(): boolean {
		return this.service.get((x) => x.matCommonUi.depositBonus?.termsVisible, true);
	}
}
